import { useTranslation } from 'react-i18next';
import { withLocalize } from '../hoc/with-localize';
import Stack from '@mui/material/Stack';

import LockedSvg from '../../assets/icons-100/locked.svg';

import UniCreditInformationalContent from '../uni-credit-informational-content';
import UniCreditContactBank from '../uni-credit-contact-bank';
import UniCreditTypography from '../uni-credit-typography';
import UniCreditFindBankOffice from '../uni-credit-find-bank-office';

export type UniCreditNotPossibleProps = {
  reason: string,
  onContactBankClick?: () => void,
};

function UniCreditNotPossible({
  reason,
  onContactBankClick,
}: UniCreditNotPossibleProps) {
  const { t } = useTranslation();

  return (
    <UniCreditInformationalContent
      icon={LockedSvg}
      title={t(`notPossible.title.${reason}`)}
    >
      <UniCreditTypography type='body' color='k10'>
        {t('notPossible.description')}
      </UniCreditTypography>

      <Stack mt={{ xs: 3, md: 5 }}>
        <UniCreditContactBank {...(onContactBankClick && { onClick: onContactBankClick })} />
        <UniCreditFindBankOffice sx={{ mt:2 }} />
      </Stack>
    </UniCreditInformationalContent>
  );
}

export default withLocalize(UniCreditNotPossible);
